import { make } from 'vuex-pathify'
import Vue from 'vue'
import store from '../index'

const state = {
  loading: [false, false],
}

const mutations = make.mutations(state)

const createJob = async ({ state }, { reportCode, filter = {} }) => {
  const type = filter.type || 0
  Vue.set(state.loading, type, true)

  try {
    return await store.dispatch('reportJobStore/createJob', {
      module: 'manage',
      reportCode,
      format: type === 0 ? 'pdf' : 'csv',
      filters: filter,
    })
  } finally {
    Vue.set(state.loading, type, false)
  }
}

const actions = {
  getDefaultingCustomers: (ctx, filter = {}) => createJob(ctx, { reportCode: 'defaultingCustomers', filter }),
  getFiscalNotes: (ctx, filter = {}) => createJob(ctx, { reportCode: 'fiscalNotes', filter }),
  getSchedules: (ctx, filter = {}) => createJob(ctx, { reportCode: 'schedules', filter }),
  getSyncs: (ctx, filter = {}) => createJob(ctx, { reportCode: 'syncs', filter }),
  getDre: (ctx, filter = {}) => createJob(ctx, { reportCode: 'dre', filter }),
  getBillingByUser: (ctx, filter = {}) => createJob(ctx, { reportCode: 'billingByUser', filter }),
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
